// import { DetailBorrowFormTrainContainer } from "../../../../containers/borrowSystem/BorrowForm/JuristicType/DetailBorrowFormTrainContainer"
import { JobPositionFormTrainContainer } from "../../../containers/borrowSystem/BorrowForm/JobPositionFormTrainContainer"

export function JobPositionFormTrainPage() {
    return (
        <JobPositionFormTrainContainer />
    )
}